import { resolveTenantHost } from '~/utils/resolveTenantHost'

const resolveTenantOrigin = (): string => {
  const requestUrl = useRequestURL()
  const requestHeaders = useRequestHeaders()
  const forwardedProto = String(requestHeaders['x-forwarded-proto'] || '')
    .split(',')[0]
    .trim()
    .replace(/:$/, '')
  const tenantHost = import.meta.server
    ? resolveTenantHost([
        String(requestHeaders['x-original-host'] || ''),
        String(requestHeaders['x-forwarded-host'] || ''),
        String(requestHeaders.host || ''),
        requestUrl.host,
      ])
    : resolveTenantHost([window.location.host])

  if (!tenantHost) return ''

  const protocol = import.meta.server
    ? (forwardedProto || 'https')
    : window.location.protocol.replace(/:$/, '')

  return `${protocol}://${tenantHost}`
}

export default defineNuxtPlugin(() => {
  const tenantOrigin = resolveTenantOrigin()
  if (tenantOrigin) {
    updateSiteConfig({ url: tenantOrigin })
  }
})
